import React, { useRef } from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import PlayButton from '@embed/components/common/PlayButton';
import { useTranslation } from '@embed/hooks/react-i18nextLazy';
import { THUMBNAIL_SIZE } from '@embed/styled';
import useCaptionTimeout from './useCaptionTimeout';
const [WIDTH] = THUMBNAIL_SIZE;
const Wrapper = styled('div') `
  height: 100%;
  position: relative;
  width: 100%;

  &:hover .fw-meta {
    background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 1));
  }
`;
const Meta = styled('div') `
  align-items: stretch;
  background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.6));
  background-size: 100% ${(props) => (props.isCaptionHidden ? '0%' : '100%')};
  background-position: center bottom;
  background-repeat: no-repeat;
  bottom: 0;
  display: flex;
  flex-direction: column;
  font-size: ${(props) => props.containerWidth
    ? Math.round((props.containerWidth / WIDTH) * 16) // Calculate font size for responsive grid
    : 16}px !important;
  font-weight: bold !important;
  justify-content: flex-end;
  left: 0;
  margin: 0;
  min-height: 50%;
  position: absolute;
  width: 100%;
  transition: background-size 0.1s;
`;
const CaptionPadding = styled('div') `
  padding: 7%;
`;
const Caption = styled('h5') `
  color: #fff !important;
  font-family: inherit !important;
  font-size: inherit !important;
  font-weight: bold !important;
  line-height: 1.33 !important;
  text-overflow: ellipsis;
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.8);
  margin: 0 !important;

  ${(props) => props.isLarge &&
    `
    font-size: 22px !important;
    font-weight: 600 !important;
    line-height: 30.05px !important;
  `}

  opacity: ${(props) => (props.isCaptionHidden ? '0' : '1')};
  transition: opacity 0.3s;

  display: block;
  display: -webkit-box;

  line-clamp: 3;
  -webkit-line-clamp: 3;
  box-orient: vertical;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding: 0 !important;
`;
const ThumbnailBody = (props) => {
    const { children, mode, 
    //video,
    caption, hidePlayButton, hideCaption, delayCaption, isLarge, isInViewport, } = props;
    //let { caption } = video
    const { t } = useTranslation();
    const wrapperRef = useRef();
    const [isCaptionHidden,
    // { onMouseEnter, onMouseLeave }
    ] = useCaptionTimeout(hideCaption, { delay: delayCaption });
    return (<Wrapper ref={wrapperRef}>
      <PlayButton aria-label={t(`Play {{caption}}`, { caption })} css={css `
          z-index: 2;
        `} hidePlayIcon={hidePlayButton} tabIndex={isInViewport ? 1 : -1}/>

      <Meta css={css `
          z-index: 2;
        `} className="fw-meta" isCaptionHidden={isCaptionHidden || !caption} mode={mode} containerWidth={wrapperRef && wrapperRef.current && wrapperRef.current.offsetWidth}>
        {caption && (<CaptionPadding>
            <Caption isCaptionHidden={isCaptionHidden} isLarge={isLarge} className="fw-thumbnail-caption">
              {caption}
            </Caption>
          </CaptionPadding>)}
      </Meta>

      {children}
    </Wrapper>);
};
export default ThumbnailBody;
